import { ReleaseState } from "../../../types/models/store";

const EDIT_RELEASE_Info = "SET_EDIT_RELEASE_TRACK";

const initState = {
  releaseInfo: {},
  promotion: {}
};

const ReduxState = (state: ReleaseState = initState, action: any) => {
  switch (action.type) {
    case EDIT_RELEASE_Info:
      return { ...state, releaseInfo: action.payload };
    default:
      return { ...state };
  }
};

export default ReduxState;
